"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var TableSchemaContext_1 = require("./TableSchemaContext");

function useTableSchema() {
  var _react_1$useContext = react_1.useContext(TableSchemaContext_1.TableSchemaContext),
      tablesList = _react_1$useContext.tablesList,
      applicationsList = _react_1$useContext.applicationsList,
      loading = _react_1$useContext.loading,
      error = _react_1$useContext.error;

  return {
    tablesList: tablesList,
    applicationsList: applicationsList,
    loading: loading,
    error: error
  };
}

exports.useTableSchema = useTableSchema;